import React, { useContext } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import { getAssetUrl } from '../../helpers/get-asset-url';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../Store';

function HeadTags() {
	const touchIconDimensions = ['180x180', '192x192', '192x192', '144x144', '120x120', '114x114', '72x72'];
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const [state] = useContext(AppContext);
	const { t } = useTranslation('translation');

	const siteOrigin = window.location.origin;
	const robotsContent = onelpsParams.headTags?.meta?.find((el) => el.name === 'robots')?.content;
	const showUskLabel = onelpsParams.uskLabel?.show && onelpsParams.country === 'DE';

	return (
		<HelmetProvider>
			<Helmet htmlAttributes={{ lang: state.language }}>

				{touchIconDimensions.map((dimension, index) => (
					<link
						key={index}
						rel='apple-touch-icon'
						sizes={dimension}
						href={`${getAssetUrl()}/${onelpsParams.gameId}-apple-touch-icon-${dimension}-precomposed.png`}
					/>
				))}

				<link
					rel='icon'
					href={`${getAssetUrl()}/favicon-${onelpsParams.gameId}.ico`}
				/>

				<link
					rel='canonical'
					href={siteOrigin}
				/>

				{showUskLabel && <link
					rel="age-de-xml"
					href="age-de.xml" />}

				{robotsContent && (
					<meta
						name="robots"
						content={robotsContent}
					/>
				)}

				<meta
					property='og:url'
					content={siteOrigin}
				/>

				<meta
					name='description'
					content={t(`headTags.meta.description.${onelpsParams.gameId}`)}
				/>

				<meta
					property='og:title'
					content={t(`headTags.pageTitle.${onelpsParams.gameId}`)}
				/>

				<meta
					property="og:site_name"
					content={t(`headTags.pageTitle.${onelpsParams.gameId}`)}
				/>

				<meta
					property='og:type'
					content='game'
				/>

				<meta
					property="og:description"
					content={t(`headTags.meta.description.${onelpsParams.gameId}`)}
				/>

				<title>{t(onelpsParams.headTags.pageTitleTranslationKey)}</title>

			</Helmet>
		</HelmetProvider>
	);
}

export default HeadTags;
